import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { TherapistClientListItemDto } from '@therapist/shared/models/client/therapist-client-list-item.dto';
import { HttpClient } from '@angular/common/http';
import { TherapistClientDto } from '@therapist/shared/models/client/therapist-client.dto';
import { TherapistClientCreateDto } from '@therapist/shared/models/client/therapist-client-create.dto';
import { TherapistClientSearchItemDto } from '@therapist/shared/models/client/therapist-client-search-item.dto';

@Injectable({ providedIn: 'root' })
export class TherapistClientApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/client`;
  }

  getAll(): Observable<TherapistClientListItemDto[]> {
    return this.#http.get<TherapistClientListItemDto[]>(`${this.endpoint}`);
  }

  getById(id: string): Observable<TherapistClientDto> {
    return this.#http.get<TherapistClientDto>(`${this.endpoint}/${id}`);
  }

  save(client: TherapistClientCreateDto): Observable<TherapistClientDto> {
    return this.#http.post<TherapistClientDto>(`${this.endpoint}`, client);
  }

  update(client: TherapistClientCreateDto): Observable<TherapistClientDto> {
    return this.#http.put<TherapistClientDto>(`${this.endpoint}`, client);
  }

  isEmailValid(email: string): Observable<boolean> {
    return this.#http.get<boolean>(`${this.endpoint}/is-email-valid/${email}`);
  }

  isSvNrValid(svnr: string): Observable<boolean> {
    return this.#http.get<boolean>(`${this.endpoint}/is-svnr-valid/${svnr}`);
  }

  searchByName(name: string): Observable<TherapistClientSearchItemDto[]> {
    return this.#http.get<TherapistClientSearchItemDto[]>(`${this.endpoint}/search-by-name?name=${name}`);
  }

  resendInvite(clientId: string): Observable<void> {
    return this.#http.put<void>(`${this.endpoint}/${clientId}/invite`, {});
  }
}
